import { ScrollTrigger } from '../globals/gsap';

import Default from './default';

class Base extends Default {
	namespace = 'base';

	heros = [];

  beforeLeave = (data) => {
    super.beforeLeave(data);
  };

  afterLeave = (data) => {
    super.afterLeave(data);
  }

	beforeEnter = data => {
		const scope = data.next.container;
		super.beforeEnter(data);
	};
	
	afterEnter = (data) => {
		super.afterEnter(data);
	}

}

export default new Base();
